export const PF_UPDATE_SEARCH_STRING = 'PF_UPDATE_SEARCH_STRING';
export const PF_CLEAR_SUGGESTIONS = 'PF_CLEAR_SUGGESTIONS';
export const PF_GET_SUGGESTIONS_SUCCESS = 'PF_GET_SUGGESTIONS_SUCCESS';
export const PF_GET_SUGGESTIONS_ERROR = 'PF_GET_SUGGESTIONS_ERROR';
export const PF_SET_SEARCH_SUGGESTIONS_OPEN = 'PF_SET_SEARCH_SUGGESTIONS_OPEN';
